import dayjs from "dayjs";
import DealNotificationDto, { DealNotificationStatuses } from "../../dto/Notification/DealNotificationDto";
import { SupportedLanguages } from "../Settings/TranslationModel";
import exhaustiveCheck from "../../utils/exhaustiveCheck";
import i18n from "../../i18n";

type DealNotificationModel = Omit<DealNotificationDto, "creationDate" | "responseDate" | "closedDate"> & {
  creationDate: dayjs.Dayjs;
  responseDate?: dayjs.Dayjs;
  closedDate?: dayjs.Dayjs;
};

export default DealNotificationModel;

export class DealNotificationDataConverter {
  static convertDealNotification(notification: DealNotificationDto): DealNotificationModel {
    return {
      ...notification,
      creationDate: dayjs(notification.creationDate),
      responseDate: notification.responseDate ? dayjs(notification.responseDate) : undefined,
      closedDate: notification.closedDate ? dayjs(notification.closedDate) : undefined,
    };
  }

  static convertDealNotifications(notifications: Array<DealNotificationDto>): Array<DealNotificationModel> {
    return notifications.map((x) => this.convertDealNotification(x));
  }
}

export class DealNotificationUtils {
  static isSameQuestion(a: Pick<DealNotificationModel, "id" | "officeType">, b: Pick<DealNotificationModel, "id" | "officeType">) {
    return a.id === b.id && a.officeType === b.officeType;
  }
  static getRecipientIds(notification: Pick<DealNotificationModel, "manager" | "recipientIds">): Array<number> {
    return Array.from(new Set([notification.manager.id, ...(notification.recipientIds || [])]));
  }

  static isRequestRecipient(notification: Pick<DealNotificationModel, "manager" | "recipientIds">, userId: number) {
    return this.getRecipientIds(notification).includes(userId);
  }

  static isActionRequiredForUser(
    notification: Pick<DealNotificationModel, "notificationStatus" | "manager" | "requester" | "recipientIds">,
    userId: number,
  ) {
    if (notification.notificationStatus === "REQUESTED") {
      return this.isRequestRecipient(notification, userId);
    }

    if (notification.notificationStatus === "RESPONDED") {
      return notification.requester.id === userId;
    }

    return false;
  }

  static getDealNotificationLabelByStatus(status: DealNotificationStatuses, lng: SupportedLanguages) {
    switch (status) {
      case "REQUESTED":
        return i18n.t("request_sended", { lng });
      case "RESPONDED":
        return i18n.t("response_recieved", { lng });
      case "CLOSED":
        return i18n.t("closed", { lng });
      default:
        return exhaustiveCheck(status);
    }
  }
}
